import React, { useEffect } from "react";
import LinesChart from "../components/dashboard/LinesChartTMAN";
import BarsChart from "../components/dashboard/BarsChartTMAN";
import PiesChart from "../components/dashboard/PiesChartTMAN";
import { useDashboars } from "../../hooks/useDashboars";

export const InicioTman = () => {

    const {
        listarUnidadesEnMantenimiento,
        unidadesEnMantenimiento,
        listarOTPorMes,
        otPorMes,
        listarOTPorEstado,
        otPorEstado,
        listarRepuestosSinStock,
        repuestosSinStock,
        obtenerBimsSinAtender,
        cantidadBimsSinAtender,
        listartUnidadesConMasBims,
        unidadesConMasBims
    } = useDashboars()

    useEffect(() => {
        const funcionReady = async () => {
            await listarUnidadesEnMantenimiento()
            await listarOTPorMes()
            await listarOTPorEstado()
            await listarRepuestosSinStock()
            await obtenerBimsSinAtender()
            await listartUnidadesConMasBims()
        }

        funcionReady()
    },[])

    

    return (
        <>
            <div className="lg:w-auto lg:text-center lg:mb-8 grid grid-flow-col rounded  h-[50px] flex justify-stretch text-2xl p-2">
                ¡Bienvenido! - Módulo de Mantenimiento
            </div>

            <div className="lg:flex lg:flex-col grid grid-flow-col justify-stretch ">
                <div className="bg-black border rounded m-2 h-[100px] flex justify-center">
                    <div className="text-[50px] my-auto ">
                        <i className=" fa fa-bus text-green-500 " />
                    </div>
                    <div className="text-xl my-auto  m-3">
                        <div className="text-2xl text-green-300">{unidadesEnMantenimiento.length}</div>

                        <div className="">Mantenimiento</div>
                    </div>
                </div>
                {/* <div className="bg-black border rounded m-2 h-[100px] flex justify-center">
                    <div className="text-[50px] my-auto ">
                        <i className=" fa fa-address-card-o text-red-500 " />
                    </div>
                    <div className="text-xl my-auto  m-3">
                        <div className="text-2xl text-red-300">5</div>

                        <div className="">Vencimientos</div>
                    </div>
                </div> */}

                <div className="bg-black border rounded m-2 h-[100px] flex justify-center">
                    <div className="text-[50px] my-auto ">
                        <i className=" fa fa-shopping-basket text-orange-500 " />
                    </div>
                    <div className="text-xl my-auto  m-3">
                        <div className="text-2xl text-orange-300">{repuestosSinStock.length}</div>

                        <div className="">Repuestos sin Stock</div>
                    </div>
                    {/* <BarsChart /> */}
                </div>

                <div className="bg-black border rounded m-2 h-[100px] flex justify-center">
                    <div className="text-[50px] my-auto ">
                        <i className=" fa fa-envelope-o text-blue-500 " />
                    </div>
                    <div className="text-xl my-auto  m-3">
                        <div className="text-2xl text-blue-300">{cantidadBimsSinAtender}</div>

                        <div className="">BIM's sin atender</div>
                    </div>
                </div>
            </div>

            <div className="lg:flex-col grid grid-flow-col lg:flex-col lg:flex justify-stretch w-[100%]">
                <div className='bg-black border rounded m-2 h-[300px] lg:h-auto w-auto'>
                    <LinesChart 
                        dataEnviada={
                            {
                                labels: otPorMes.map(e => e.mes),
                                datasets: [
                                    {
                                        label: 'MANTENIMIENTO UNIDADES',
                                        data: otPorMes.map(e => e.cantidad),
                                        fill : true,
                                        borderColor: 'rgba(80,190,5,1)',
                                        backgroundColor: 'rgba(80,190,5,0.5)',
                                        pointRadius: 5,
                                        pointBorderColor: 'rgba(80,190,5,1)',
                                        pointBackgroundColor: 'rgba(80,195,4,1)',
                                    },
                                ],
                            }
                        }
                    />
                </div>
                {/* <div className=' bg-black border rounded m-2 h-[300px] lg:h-auto w-auto'>
                    <PiesChart 
                        dataEnviada={
                            {
                                labels: otPorEstado.map(e => e.nomEstado),
                                datasets: [
                                    {
                                        label: 'Cantidad',
                                        data: otPorEstado.map(e => e.cantidad),
                                        backgroundColor: ['rgba(255, 99, 12, 0.8)', 'rgba(30, 30, 30, 0.8)', 'rgba(54, 162, 235, 0.8)','rgba(250,250,23,0.8)'],
                                        borderColor: ['rgba(255, 99, 12, 1)', 'rgba(30, 30, 30, 1)', 'rgba(54, 162, 235, 1)','rgba(250,250,23,1)'],
                                        borderWidth: 1,
                                        hoverBackgroundColor: ['rgba(255, 99, 12, 0.4)', 'rgba(30, 30, 30, 0.4)', 'rgba(54, 162, 235, 0.4)','rgba(250,250,23,0.4)'],
                                        hoverBorderColor: ['rgba(255, 99, 12, 1)', 'rgba(30, 30, 30, 1)', 'rgba(54, 162, 235, 1)','rgba(250,250,23,1)'],
                                        hoverBorderWidth: 2,
                                    },
                                ],
                            }
                        }
                    />
                </div> */}
            </div>
            
            <div className="lg:flex lg:flex-col grid grid-flow-col justify-stretch ">
                <div className='bg-black border rounded m-2 h-[300px] flex justify-center py-10'>
                    <BarsChart 
                        dataEnviada={
                            {
                                labels: unidadesConMasBims.map(e => e.nomUnidad),
                                datasets: [
                                    {
                                        label: 'BIM´s',
                                        data: unidadesConMasBims.map(e => e.bimPorUnidad),
                                        backgroundColor: [
                                            'rgba(75, 192, 192, 0.2)',
                                            'rgba(255, 99, 132, 0.2)',
                                            'rgba(54, 162, 235, 0.2)',
                                            'rgba(255, 206, 86, 0.2)',
                                            'rgba(153, 102, 255, 0.2)',
                                            'rgba(255, 159, 64, 0.2)',
                                        ],
                                        borderColor: [
                                            'rgba(75, 192, 192, 1)',
                                            'rgba(255, 99, 132, 1)',
                                            'rgba(54, 162, 235, 1)',
                                            'rgba(255, 206, 86, 1)',
                                            'rgba(153, 102, 255, 1)',
                                            'rgba(255, 159, 64, 1)',
                                        ],
                                        borderWidth: 2,
                                        borderSkipped: 'bottom',
                                        borderRadius: 5,
                                        borderDashOffset: 5,
                                        hoverBackgroundColor: [
                                            'rgba(75, 192, 192, 0.4)',
                                            'rgba(255, 99, 132, 0.4)',
                                            'rgba(54, 162, 235, 0.4)',
                                            'rgba(255, 206, 86, 0.4)',
                                            'rgba(153, 102, 255, 0.4)',
                                            'rgba(255, 159, 64, 0.4)',
                                        ],
                                        hoverBorderColor: [
                                            'rgba(75, 192, 192, 1)',
                                            'rgba(255, 99, 132, 1)',
                                            'rgba(54, 162, 235, 1)',
                                            'rgba(255, 206, 86, 1)',
                                            'rgba(153, 102, 255, 1)',
                                            'rgba(255, 159, 64, 1)',
                                        ],
                                    },
                                ],
                            }
                        }
                    />
                </div>
                <div className=' bg-black border rounded m-2 h-[300px] lg:h-auto w-auto'>
                    <PiesChart 
                        dataEnviada={
                            {
                                labels: otPorEstado.map(e => e.nomEstado),
                                datasets: [
                                    {
                                        label: 'Cantidad',
                                        data: otPorEstado.map(e => e.cantidad),
                                        backgroundColor: ['rgba(255, 99, 12, 0.8)', 'rgba(30, 30, 30, 0.8)', 'rgba(54, 162, 235, 0.8)','rgba(250,250,23,0.8)'],
                                        borderColor: ['rgba(255, 99, 12, 1)', 'rgba(30, 30, 30, 1)', 'rgba(54, 162, 235, 1)','rgba(250,250,23,1)'],
                                        borderWidth: 1,
                                        hoverBackgroundColor: ['rgba(255, 99, 12, 0.4)', 'rgba(30, 30, 30, 0.4)', 'rgba(54, 162, 235, 0.4)','rgba(250,250,23,0.4)'],
                                        hoverBorderColor: ['rgba(255, 99, 12, 1)', 'rgba(30, 30, 30, 1)', 'rgba(54, 162, 235, 1)','rgba(250,250,23,1)'],
                                        hoverBorderWidth: 2,
                                    },
                                ],
                            }
                        }
                    />
                </div>
                {/* <div className='bg-black border m-2 h-[300px]  '>
                    <PiesChart />
                </div>  */}
                {/* <div className='bg-black border rounded m-2 h-[300px] w-[400px] '>
                    <PiesChart />
                </div> */}
                {/* <div className='bg-black border m-2'>
                    <Graphics />
                </div> */}
            </div>
        </>
    );
};
